import { digitGroup } from 'src/helpers'

export const renderReturnLetterTotalColumn = (title, subtitle) => {
  if (!title) return '-'

  return `
    <div class="column">
      <span class="text-weight-medium">${digitGroup(title)} DO</span>
      <span class="text-grey-8">
        Rp ${digitGroup(subtitle)}
      </span>
    </div>
  `
}

export const returnLetterAgingTable = [
  {
    name: 'supplier_name',
    field: 'supplier_name',
    label: 'Vendor',
    align: 'left',
    sortable: true,
    rowClass: 'td-width-small text-weight-medium'
  },
  {
    name: '1_week_total_do',
    field: row => renderReturnLetterTotalColumn(row?.['1_week_total_do'], row?.['1_week_total_price']),
    label: '1 Minggu',
    align: 'left',
    sortable: true,
    headerClasses: 'bg-primary text-white',
    rowClass: 'td-width-small'
  },
  {
    name: '2_week_total_do',
    field: row => renderReturnLetterTotalColumn(row?.['2_week_total_do'], row?.['2_week_total_price']),
    label: '2 Minggu',
    align: 'left',
    sortable: true,
    headerClasses: 'bg-blue text-white',
    rowClass: 'td-width-small'
  },
  {
    name: '3_week_total_do',
    field: row => renderReturnLetterTotalColumn(row?.['3_week_total_do'], row?.['3_week_total_price']),
    label: '3 Minggu',
    align: 'left',
    sortable: true,
    headerClasses: 'bg-yellow-9 text-white',
    rowClass: 'td-width-small'
  },
  {
    name: 'over_3_weeks_total_do',
    field: row => renderReturnLetterTotalColumn(row?.over_3_weeks_total_do, row?.over_3_weeks_total_price),
    label: '+3 Minggu',
    align: 'left',
    sortable: true,
    headerClasses: 'bg-negative text-white',
    rowClass: 'td-width-small'
  },
  {
    name: 'grand_total_do',
    field: row => renderReturnLetterTotalColumn(row?.grand_total_do, row?.grand_total_price),
    label: 'Grand Total',
    align: 'left',
    sortable: true,
    rowClass: 'td-width-small'
  }
]
